import Axios from "axios";
import {
    SET_HRM_SECTION_LIST,
    UNSET_HRM_SECTION_LIST,
  } from "@/store/mutation-types";
import { saveUpdateHrmSection, getHrmSectionList } from "@/store/api";

// initial state
const state = {
  getHrmSectionList: [],
};

const getters = {
  getHrmSectionList(state) {
    return state.getHrmSectionList;
  },
};

const mutations = {
  [SET_HRM_SECTION_LIST](state, data) {
    state.getHrmSectionList = data;
  },
  [UNSET_HRM_SECTION_LIST](state) {
    state.getHrmSectionList = [];
  },
};

const actions = {
  saveUpdateHrmSection({ commit }, data) {
    commit("SET_LOADING", {color: "primary"});
    return new Promise((resolve, reject) => {
      Axios.post(saveUpdateHrmSection, data)
        .then(function (response) {
          resolve(response);
        })
        .catch(function (error) {
          reject(error);
        })
        .then((always) => {
            commit("UNSET_LOADING");
        });
    });
  },

  getHrmSectionList({ commit }, data) {
    return new Promise((resolve, reject) => {
      Axios.get(getHrmSectionList, data)
        .then(function (response) {
          commit('SET_HRM_SECTION_LIST', response.data.data)
          resolve(response);
        })
        .catch(function (error) {
          commit('UNSET_HRM_SECTION_LIST')
          reject(error);
        })
        .then((always) => {
        });
    });
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
